import React, { FC } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import { TextField } from '@src/components/TextField';
import { FORGET_PASSWORD_ROUTE, REGISTER_ROUTE } from '@src/Routes/links';
import { GOOGLE_CAPTCHA_SITE_KEY } from '@src/constants';
import { Button } from '@src/components/Button';
import { PasswordInput } from '@src/components/PasswordInput';
import { validateEmail } from '@src/util/validation';
import { LoginFormKey } from '../enums/loginFormKey.enum';
import { LoginStepProps } from './props';
import './styles.scss';

export const LoginStep: FC<LoginStepProps> = ({ formData, isLoading, setFormData, onLogin }) => {
  const isLoginButtonDisabled =
    !formData.password.trim() ||
    !formData.email.trim() ||
    !validateEmail(formData.email) ||
    !formData.captcha ||
    isLoading;

  return (
    <div className="login-step fade-in">
      <div className="login-step__header-content">
        <h3>Log in using email</h3>

        <p>
          Don’t have an account yet?
          <Link className="login-step__log-in" to={REGISTER_ROUTE}>
            Register
          </Link>
        </p>
      </div>

      <div>
        <TextField
          defaultValue={formData.email}
          fullWidth={true}
          label="Email"
          onChange={value => setFormData({ ...formData, [LoginFormKey.EMAIL]: value.trim() })}
          placeholder="Email"
          type="email"
          wrapperClassName="login-step__input"
        />

        <PasswordInput
          isValidationRulesVisible={false}
          onChange={value => setFormData({ ...formData, [LoginFormKey.PASSWORD]: value.trim() })}
          placeholder="Password"
          textFieldProps={{
            label: 'Password',
          }}
          value={formData.password}
        />

        <ReCAPTCHA
          className="login-step__captcha"
          onChange={value => setFormData({ ...formData, [LoginFormKey.CAPTCHA]: value })}
          sitekey={GOOGLE_CAPTCHA_SITE_KEY}
        />
      </div>

      <div className="login-step__actions">
        <Link className="login-step__forgot-password" to={FORGET_PASSWORD_ROUTE}>
          Forgot your password?
        </Link>

        <Button className="login-step__continue-button" isDisabled={isLoginButtonDisabled} onClick={onLogin}>
          Login
        </Button>
      </div>
    </div>
  );
};
